module.exports = __webpack_public_path__ + "img/vector.27dd5d01.svg";